import { Box, Typography, styled, useTheme } from "@mui/material";
import { Calendar, Time } from "assets/Icon";

import useIsMobileView from "hooks/useIsMobileView";

export function BoxNotification({
  notification,
  onNotificationClick,
  isShowAll,
}) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();
  const splitIp = (text) => {
    const textIp = text?.split("IP");
    const Ip = textIp?.[1]?.split("دستگاه");
    return Ip?.[0];
  };

  return (
    <BoxItemNotification
      dir="rtl"
      onClick={() => {
        !notification.isRead && onNotificationClick(notification);
      }}
      isRead={notification.isRead}
    >
      {!isMobileView && isShowAll && (
        <Box>
          <BoxIcon>
            <ion-icon name="notifications-outline" />
          </BoxIcon>
        </Box>
      )}

      <Box width="100%">
        <BoxTitleItem>
          <Typography variant="h4" fontWeight={500}>
            {notification.title}
          </Typography>

          {notification.isRead && <ion-icon name="checkmark"></ion-icon>}
        </BoxTitleItem>

        {isMobileView && (
          <BoxDetails>
            <Box>
              <Calendar color={theme.palette.text.secondary} />
              <Typography variant="subtitle2" marginRight={0.5}>
                {notification.date}
              </Typography>
            </Box>

            <Box>
              <Time color={theme.palette.text.secondary} />
              <Typography variant="subtitle2" marginRight={0.5}>
                {notification.time}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h4" color="text.secondary" marginLeft={0.5}>
                IP
              </Typography>
              <Typography variant="subtitle2">
                {splitIp(notification.text)}
              </Typography>
            </Box>
          </BoxDetails>
        )}

        <Typography variant="subtitle1" marginTop={2} fontWeight={400}>
          {notification.text}
        </Typography>
      </Box>
    </BoxItemNotification>
  );
}

const BoxItemNotification = styled(Box)(({ theme, isRead }) => ({
  display: "flex",
  alignItems: "center",
  background: !isRead && theme.palette.background.primaryGradient,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.common.white}10`,
  marginBottom: theme.spacing(1),
  padding: theme.spacing(2),
  color: theme.palette.text.main,
  cursor: "pointer",
  transition: "all 0.3s",

  "&:hover": {
    background: theme.palette.modules.backgroundHoverNotification,
  },
}));

const BoxTitleItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "ion-icon": {
    color: theme.palette.secondary.main,
    fontSize: "24px",
  },
}));

const BoxIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  overflow: "hidden",
  borderRadius: "50%",
  justifyContent: "center",
  width: "65px",
  height: "65px",
  alignItems: "center",
  background: theme.palette.modules.backgroundIconNotification,
  border: `1px solid ${theme.palette.secondary.main}`,
  marginLeft: "15px",

  "ion-icon": {
    color: theme.palette.secondary.main,
    fontSize: "24px",
  },
}));

const BoxDetails = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.9),
  display: "flex",
  justifyContent: "space-between",
  ".MuiBox-root": {
    display: "flex",
    alignItems: "center",
  },
  "ion-icon": {
    fontSize: "20px",
    marginLeft: theme.spacing(0.3),
  },
}));

export default BoxNotification;
